import React from "react";
import PageHero from "../components/PageHero";
import { SectionLabel } from "../components/Shared";
import { PRIVACY_SECTIONS, IMAGES } from "../config/siteConfig";

export default function PrivacyPage() {
  return (
    <>
      <PageHero
        label="Legal"
        title="Inrisoft"
        highlight="Privacy Policy."
        subtitle="How Inri Software Private Limited collects, uses, shares and protects your personal information."
        image={IMAGES.hero}
      />
      <section className="bg-[#F7F7F5] py-24 md:py-36" data-testid="privacy-section">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 space-y-10">
          <SectionLabel>Privacy Policy</SectionLabel>
          {PRIVACY_SECTIONS.map((s) => (
            <article key={s.title}>
              <h2 className="font-display text-2xl md:text-3xl text-[#111111] mb-4">{s.title}</h2>
              <p className="font-body text-[#555] leading-relaxed">{s.body}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
